import { createFileRoute } from "@tanstack/react-router";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const studentsDetailSearchSchema = parseableSearchSchema(
  Schema.Struct({
    filter: optionalLiteralParam("all", "complete", "partial", "incomplete"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/students/")({
  validateSearch: studentsDetailSearchSchema
});
